import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { ResponseDto, OrganizationTaxRateDto } from "@mimber/schema"
import { taxRatesKeys } from "../tax-rates.utils"

/**
 * Organization-specific hook for fetching the organization's tax rates.
 * Can only be used in mimber-organization app.
 */
export const useTaxRates = (
  options?: UseQueryOptions<ResponseDto<OrganizationTaxRateDto[]>, Error>
): UseQueryResult<ResponseDto<OrganizationTaxRateDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useTaxRates")

  const { server } = useServerContext()

  return useQuery({
    queryKey: taxRatesKeys.findAll(),
    queryFn: async () => {
      const response =
        await server.get<ResponseDto<OrganizationTaxRateDto[]>>("tax-rates")
      return response.data
    },
    ...options,
  })
}
